import React from 'react';

function NotFound() {
  return (
    <div className="not-found">
      <h1>404 - Page Not Found</h1>
    </div>
  );
}

export default NotFound;
